<template lang="pug">
#filtros.mb-3
    el-collapse(style='border: none')
        el-collapse-item(name='filtros')
            span.titulo(slot='title') {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtroSubtitulo') }}

            el-form.fields(label-position='top', size='mini')
                el-form-item.subTrading(
                    v-if='isUsuarioLDC'
                )
                    label Trading
                    el-select.select-subTrading(
                        v-model='filtros.subTrading',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='subTrading in listaSubTradings',
                            :key='subTrading.id',
                            :label='subTrading.nome',
                            :value='subTrading.id'
                        )
                            | {{ subTrading.nome }}
                            
                el-form-item.cultura
                    label {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.cultura') }}
                    el-select.select-cultura(
                        v-model='filtros.cultura',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='cultura in listaCulturas',
                            :key='cultura.id',
                            :label='cultura.nome',
                            :value='cultura.id'
                        )
                            | {{ cultura.nome }}

                el-form-item.safra
                    label {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.safra') }}
                    el-select.select-safra(
                        v-model='filtros.safra',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='safra in listaSafras',
                            :key='safra.id',
                            :label='safra.ano',
                            :value='safra.id'
                        )
                            | {{ safra.ano }}
                
                //- ARGENTINA ---------------------------------------------------------------------

                el-form-item.estado(v-if='this.usuarioLogado.ambienteLogado === this.ambientes.ARGENTINA')
                    label {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.estado') }}
                    el-select.select-estado(
                        v-model='filtros.estado',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='estado in listaEstados',
                            :key='estado.id',
                            :label='estado.nome',
                            :value='estado.id'
                        )
                            | {{ estado.nome }}

                el-form-item.fornecedor(v-if='this.usuarioLogado.ambienteLogado === this.ambientes.ARGENTINA')
                    label {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.fornecedor') }}
                    el-select.select-fornecedor(
                        v-model='filtros.fornecedor',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='fornecedor in listaFornecedores',
                            :key='fornecedor.id',
                            :label='fornecedor.nome',
                            :value='fornecedor.id'
                        )
                            | {{ fornecedor.nome }}

                //- BRASIL ------------------------------------------------------------------------

                el-form-item.regional(
                    v-if='this.usuarioLogado.ambienteLogado === this.ambientes.BRASIL'
                )
                    label {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.regionalBunge') }}
                    el-select.select-regional-bunge(
                        v-model='filtros.regionalBunge',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='regional in listaRegionais',
                            :key='regional.id',
                            :label='regional.nome',
                            :value='regional.id'
                        )
                            | {{ regional.nome }}

                el-form-item.gerenteRegional(
                    v-if='this.usuarioLogado.ambienteLogado === this.ambientes.BRASIL'
                )
                    label {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.gerenteRegional') }}
                    el-select.select-gerente-regional(
                        v-model='filtros.gerenteRegional',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='gerenteRegional in listaGerenteRegional',
                            :key='gerenteRegional.id',
                            :label='gerenteRegional.nome',
                            :value='gerenteRegional.id'
                        )
                            | {{ gerenteRegional.nome }}

                el-form-item.gerenteComercial(
                    v-if='this.usuarioLogado.ambienteLogado === this.ambientes.BRASIL'
                )
                    label {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.gerenteComercial') }}
                    el-select.select-gerente-comercial(
                        v-model='filtros.gerenteComercial',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='gerenteComercial in listaGerenteComercial',
                            :key='gerenteComercial.id',
                            :label='gerenteComercial.nome',
                            :value='gerenteComercial.id'
                        )
                            | {{ gerenteComercial.nome }}

                el-form-item.gestor(
                    v-if='this.usuarioLogado.ambienteLogado === this.ambientes.BRASIL'
                )
                    label {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.gestorTerritorial') }}
                    el-select.select-gestor-territorial(
                        v-model='filtros.gestorTerritorial',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='gestorTerritorial in listaGestorTerritorial',
                            :key='gestorTerritorial.id',
                            :label='gestorTerritorial.nome',
                            :value='gestorTerritorial.id'
                        )
                            | {{ gestorTerritorial.nome }}

                el-form-item.status(
                    v-if='this.usuarioLogado.ambienteLogado === this.ambientes.BRASIL'
                )
                    label {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.status') }}
                    el-select.select-status(
                        v-model='filtros.status',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='status in listaStatus',
                            :key='status.id',
                            :label='status.descricao',
                            :value='status.codigo'
                        )
                            | {{ status.descricao }}

                //- PARAGUAY ----------------------------------------------------------------------

                el-form-item.departamento(
                    v-if='this.usuarioLogado.ambienteLogado === this.ambientes.PARAGUAY'
                )
                    label {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.estado') }}
                    el-select.select-estado(
                        v-model='filtros.estado',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='estado in listaEstados',
                            :key='estado.id',
                            :label='estado.nome',
                            :value='estado.id'
                        )
                            | {{ estado.nome }}

                el-form-item.proveedor(
                    v-if='this.usuarioLogado.ambienteLogado === this.ambientes.PARAGUAY'
                )
                    label {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.fornecedor') }}
                    el-select.select-fornecedor(
                        v-model='filtros.fornecedor',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        filterable
                    )
                        el-option(
                            v-for='fornecedor in listaFornecedores',
                            :key='fornecedor.id',
                            :label='fornecedor.nome',
                            :value='fornecedor.id'
                        )
                            | {{ fornecedor.nome }}
                el-form-item.actions
                    .buttons
                        el-button.mr-10(
                            icon='el-icon-delete',
                            @click='limparFiltros'
                        ) {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.limpar') }}
                        el-button(
                            type='primary',
                            icon='el-icon-receiving',
                            @click='criarFiltro'
                        ) {{ $t('mensagens.rastreabilidadeEmpresa.dashboard.filtros.filtrar') }}
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import RegionalService from '@/services/RegionalService';
import PessoaService from '@/services/PessoaService';
import LocalidadeService from '@/services/LocalidadeService';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

import { mapState } from 'vuex';

const ordem = (a, b) => {
    if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
        return -1;
    }
    if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
        return 1;
    }
    return 0;
};

export default {
    name: 'Filtros',
    emits: ['emitFiltrosDashboard'],

    data() {
        return {
            filtros: {
                cultura: '',
                safra: '',
                estado: '',
                fornecedor: '',
                regionalBunge: '',
                gerenteRegional: '',
                gerenteComercial: '',
                gestorTerritorial: '',
                status: '',
                tipoContrato: null,
                subTrading: ''
            },
            ambientes: AmbientesEmpresas,
            listaCulturas: [],
            listaSafras: [],
            listaFornecedores: [],
            listaRegionais: [],
            listaEstados: [],
            listaGerenteRegional: [],
            listaGerenteComercial: [],
            listaGestorTerritorial: [],
            listaStatus: [],
            listaSubTradings: [],
            tipoContrato: [
                {
                    label: this.$t(
                        'mensagens.rastreabilidadeEmpresa.dashboard.tipoContrato.online'
                    ),
                    value: false
                },
                {
                    label: this.$t(
                        'mensagens.rastreabilidadeEmpresa.dashboard.tipoContrato.offline'
                    ),
                    value: true
                }
            ]
        };
    },

    computed: {
        ...mapState(['usuarioLogado']),
        isUsuarioLDC() {
            return this.usuarioLogado?.isLDC === true;
        }
    },

    watch: {
        '$i18n.locale': function () {
            this.listaRegionais = [];
            this.listaGerenteRegional = [];
            this.listaGerenteComercial = [];
            this.listaGestorTerritorial = [];

            this.buscarRegionais();
            this.buscarPessoas('GERENTE_REGIONAL');
            this.buscarPessoas('GERENTE_COMERCIAL');
            this.buscarPessoas('GERENTE_TERRITORIAL');
            this.buscarStatus();
        }
    },

    created() {
        this.limparFiltros();
    },
    mounted() {
        this.buscarCulturas();
        this.buscarSafras();
        this.buscarFornecedores();
        this.buscarRegionais();
        this.buscarEstados();
        this.buscarPessoas('GERENTE_REGIONAL');
        this.buscarPessoas('GERENTE_COMERCIAL');
        this.buscarPessoas('GERENTE_TERRITORIAL');
        this.buscarStatus();
        if (this.isUsuarioLDC) {
            this.buscarSubTradings();
        }
    },

    methods: {
        async buscarCulturas() {
            if (this.listaCulturas.length) return;
            ContratoOriginacaoService.buscarCulturas()
                .then(({ data }) => {
                    this.listaCulturas = data.sort(ordem);
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },
        async buscarSafras() {
            if (this.listaSafras.length) return;
            ContratoOriginacaoService.buscarSafras()
                .then(({ data }) => {
                    this.listaSafras = data;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },
        async buscarFornecedores() {
            if (this.listaFornecedores.length) return;
            ContratoOriginacaoService.buscarBpClientes()
                .then(({ data }) => {
                    this.listaFornecedores = data.sort(ordem);
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },
        async buscarRegionais() {
            if (this.listaRegionais.length) return;
            RegionalService.buscarRegionais()
                .then(({ data }) => {
                    this.buscarStringPadraoTraduzida(data);
                    this.listaRegionais = data.sort(ordem);
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },
        async buscarEstados() {
            if (this.listaEstados.length) return;
            LocalidadeService.buscarLocalidadeNivelUm()
                .then(({ data }) => {
                    this.listaEstados = data.sort(ordem);
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },
        buscarStringPadraoTraduzida(lista) {
            let index = lista.findIndex(obj => obj.nome === 'Não atribuído');
            if (index >= 0) {
                lista[index].nome = this.$t(
                    'mensagens.rastreabilidadeEmpresa.dashboard.naoAtribuido'
                );
            }
        },
        async buscarPessoas(tipoPessoa) {
            if (
                tipoPessoa === 'GERENTE_REGIONAL' &&
                this.listaGerenteRegional.length
            ) {
                return;
            } else if (
                tipoPessoa === 'GERENTE_COMERCIAL' &&
                this.listaGerenteComercial.length
            ) {
                return;
            } else if (
                tipoPessoa === 'GERENTE_TERRITORIAL' &&
                this.listaGestorTerritorial.length
            ) {
                return;
            }
            PessoaService.buscarPessoa(tipoPessoa)
                .then(({ data }) => {
                    this.buscarStringPadraoTraduzida(data);
                    if (tipoPessoa === 'GERENTE_REGIONAL') {
                        this.listaGerenteRegional = data.sort(ordem);
                    } else if (tipoPessoa === 'GERENTE_COMERCIAL') {
                        this.listaGerenteComercial = data.sort(ordem);
                    } else if (tipoPessoa === 'GERENTE_TERRITORIAL') {
                        this.listaGestorTerritorial = data.sort(ordem);
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },
        async buscarStatus() {
            try {
                const { data } = await ContratoOriginacaoService.buscarStatus();

                this.listaStatus = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.dashboard.filtros.buscarStatusErro'
                    )
                );
            }
        },
        async buscarSubTradings() {
            try {
                const { data } = await ContratoOriginacaoService.buscarSubTradings();
                this.listaSubTradings = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSubTrading'
                    )
                );
            }
        },
        limparFiltros() {
            this.filtros = {
                cultura: '',
                safra: '',
                estado: '',
                fornecedor: '',
                regionalBunge: '',
                gerenteRegional: '',
                gerenteComercial: '',
                gestorTerritorial: '',
                status: '',
                tipoContrato: null,
                subTrading: ''
            };
            this.$emit('emitFiltrosDashboard', this.filtros);
        },

        criarFiltro() {
            this.$emit('emitFiltrosDashboard', this.filtros);
        }
    }
};
</script>

<style scoped lang="scss">
#filtros {
    background-color: var(--white);
    width: 100%;
    padding: 0 15px;
    box-shadow: $default-shadow;
    overflow: hidden;
    border-radius: 4px;

    .fields {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 15px;
        color: var(--primary);
        font-family: 'Roboto', 'sans serif';
        font-weight: 500;

        div {
            width: 100%;
        }
    }

    label {
        margin-bottom: -5px;
    }

    .el-select {
        margin-top: -20px;
        width: 100%;
    }

    .titulo {
        font-size: 14px;
        font-family: 'Roboto', 'sans serif';
        font-weight: 600;
        color: var(--primary);
    }

    .actions {
        margin-bottom: 0;

        .buttons {
            display: flex;
            margin-top: 29px;
        }
    }
}
</style>
